/**
 * The header that tells the server a sign-in request is from a Nsibi client
 * and not a script (`auth_phone/appcheck.py`).
 *
 * ── Never set VITE_NSIBI_APP_CHECK_SECRET ──────────────────────────
 * A Vite variable is INLINED into the public bundle, so the app's secret
 * would be one `curl` away from anybody who opens the site. The web app does
 * not need it: under /staff `app_check_mode = enforce` the server lets
 * requests from this app's origin (`NSIBI_WEB_APP_ORIGIN`) through for email,
 * Google and Apple sign-in, and refuses anything that sends an SMS, which the
 * web never asks for (`auth_phone/appcheck.py`, 2026-10-31). The hook stays
 * only so the header code has one shape on both clients.
 */
const SECRET: string = ((import.meta.env.VITE_NSIBI_APP_CHECK_SECRET as string | undefined) ?? '').trim();

/** The headers to add to an unauthenticated sign-in request. */
export function appCheckHeaders(secret: string = SECRET): Record<string, string> {
  return secret ? { 'X-Nsibi-App-Check': secret } : {};
}
